import { h } from 'preact'
import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color = 'currentColor', customClass = '' }: IconComponentProps) => (
  <svg class={customClass} width={width} height={height} viewBox="0 0 18 12" fill={color}>
    <path d="M7 12H11V10H7V12ZM0 0V2H18V0H0ZM3 7H15V5H3V7Z" />
  </svg>
)
